import { SectionWithExposureRate } from '../../SectionWithExposureRate';

export const getSectionTheoreticalExposureRate = (section: SectionWithExposureRate) =>
  (section.exposureRate ? section.exposureRate : section.defaultExposureRate) / 4;
